/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenItemSummaryInfo } from './EvmTokenItemSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type SomniaTokenTransferInfo = {
    STAT: SomniaTokenTransferInfo.STAT;
    TRXHA: string;
    AG: string;
    UT: number;
    MTH: string;
    ACTTP: SomniaTokenTransferInfo.ACTTP;
    BNO: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    LGIDX: string;
    TSI: EvmTokenSummaryInfo;
    TISI: EvmTokenItemSummaryInfo;
};

export namespace SomniaTokenTransferInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum ACTTP {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
        MUTATE = 'MUTATE',
        BIDDING = 'BIDDING',
        CANCEL_BIDDING = 'CANCEL_BIDDING',
        COLLECTION_BIDDING = 'COLLECTION_BIDDING',
        COLLECTION_CANCEL_BIDDING = 'COLLECTION_CANCEL_BIDDING',
        LISTING = 'LISTING',
        DELIST = 'DELIST',
        SOLD = 'SOLD',
        UPDATE_PRICE = 'UPDATE_PRICE',
        CREATE_TOKEN = 'CREATE_TOKEN',
        CREATE_COLLECTION = 'CREATE_COLLECTION',
        WITHDRAW = 'WITHDRAW',
        DEPOSIT = 'DEPOSIT',
        OBJECT_CORE = 'OBJECT_CORE',
        DELETE_RESOURCE = 'DELETE_RESOURCE',
    }


}

